import RcForKidsDetails from './RcForKidsDetails';

export default RcForKidsDetails;
